<div class='app-date-picker'>
  <input
    (focusout)='onFocusOut()'
    [id]='id'
    [ngClass]='{ "is-invalid": isInvalid() }'
    [disabled]='disabled'
    [(ngModel)]='value'
    type='text'
    mask="d0.M0.0000"
    [dropSpecialCharacters]="false"
    class='icon-calendar'
    [dpDayPicker]='calendarConfig'
    [mode]="mode"
    (ngModelChange)='onPickDate($event)'
    placeholder='Wskaż datę lub wpisz w formacie: dd.mm.rrrr'>
</div>
